// accordion.js
;(({ log }) => {
    const togglerActiveClass = 'accordion__toggler--active'
    document.querySelectorAll('.accordion').forEach(acc => {
        const sections = acc.getChildrenOnFirstLevel('accordion__section')
        const allContents = acc.querySelectorAll('.accordion__content')
        const allTogglers = acc.querySelectorAll('.accordion__toggler')
        const autoclose = acc.dataset.accordionAutoclose === "true"
        const slideTime = parseInt(acc.dataset.accordionSlideTime) || 500
        
        sections.forEach(section => {
            const toggler = section.querySelector('.accordion__toggler')
            const content = section.querySelector('.accordion__content')
            
            content.slideUp(0)
            toggler.classList.remove(togglerActiveClass)

            toggler.addEventListener('click', e => {
                if (autoclose) {
                    allContents.forEach(c => {
                        if (content != c) {
                            c.slideUp(slideTime)
                        }
                    })

                    allTogglers.forEach(t => {
                        if (toggler != t) {
                            t.classList.remove(togglerActiveClass)
                        }
                    })
                }
                content.slideToggle(slideTime)
                toggler.classList.toggle(togglerActiveClass)
            })
        })
    })
})(CNS);